import React,{ useEffect } from "react";
import { fetchTurns } from "../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions } from "../../../../../utils";
import { NumericMultiSelector } from "../../../../common/selectors/multiSelectors/numericMultiSelector/numericMultiSelector";
import { IBaseMultipleNumberSelectorProps } from "../IBaseMultipleSelectorProps";
import { MultipleNumberSelectorFilter } from "../multipleSelectorFilter/multipleNumberSelectorFilter";

export const MultipleTurnSelector: React.FC<IBaseMultipleNumberSelectorProps> = ({ autocomplete, onChange, propertyName, title, selectedKeys }) => {
    const { data, loading } = useAppSelector((store) => store.catalog.turns);
    const dispatch = useAppDispatch();

    useEffect(() => {
        data.length === 0 && dispatch(fetchTurns());
    }, [dispatch, data]);

    return autocomplete ? (
        <MultipleNumberSelectorFilter
            selectedKeys={selectedKeys}
            onChange={onChange}
            options={mapIDescriptionToDropDownOptions(data)}
            label={title}
            propertyName={propertyName}
        ></MultipleNumberSelectorFilter>
    ) : (
        <NumericMultiSelector
            onChange={onChange}
            selectedKeys={selectedKeys}
            options={mapIDescriptionToDropDownOptions(data)}
            disabled={loading}
            title={title}
            name={propertyName}
        />
    );
};
